






import AbpBase from "../../../../lib/abpbase";
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
@Component
export default class DialysisMachine extends AbpBase {

	private _activeName2 = "first"
	handleClick = (val1: any, val2: any) => {
		console.log(this._activeName2, val1, val2)
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/engineer/rule/parts/environmental.vue